export default "/static/images/build_roof_10.png?d8e8c71e8864da4e3248f07656e5f037";